import React from 'react'
import SubHeader from '../general/SubHeader'
import AboutImg from '../assets/about-img.jpg'

const About = () => {
  return (
    <>
      <SubHeader message="About Us" />


{/* About section */}
<section className='my-5'>
    <div className='container py-md-4'>

                    <p className='sec-heading'>"Launched in 2008, today Sidhha Bhairabi Store aims to deliver high-quality yet
                        affordable Cosmetic beauty products for women to fulfill their beauty needs."</p>

                        <p>Over the years, our Store has become a trusted name in the world of beauty and personal care.
            With a strong commitment to purity, quality, and customer satisfaction, we offer a wide range of cosmetic products
            that are carefully curated to suit all skin types and tones.</p>

    </div>
</section>
{/* About section ends */}


{/* values section */}
<section className='py-5 bg-blue'>
    <div className='container'>

        <div className='row'>

<div className='col-lg-4 col-md-6 col-12 my-2'>
<p className='banner-text'><i class="fa-solid fa-truck-fast text-blue"></i> Free Shipping</p>
<p className='text-muted'>Enjoy fast, free shipping on all cosmetic orders—delivered safely and quickly to your doorstep.</p>
</div>

<div className='col-lg-4 col-md-6 col-12 my-2'>
  <p className='banner-text'><i class="fa-solid fa-credit-card text-blue"></i> Return & Refund</p>
  <p className='text-muted'>Easy returns and full refunds on unused items—your satisfaction with our products is guaranteed.</p>
</div>

<div className='col-lg-4 col-md-6 col-12 my-2'>
  <p className='banner-text'><i class="fa-solid fa-headset text-blue"></i> Quick Support</p>
  <p className='text-muted'>Get prompt, friendly customer support for all inquiries—your beauty needs are our top priority.</p>
</div>


        </div>
{/* row ends */}

<img src={AboutImg} className='img-fluid px-md-5 mt-4 rounded-pill' alt="About" />

    </div>
</section>
{/* values section ends */}


{/* Testimonial section */}
<section className='my-5'>
  <div className='container'>

                    <p className='sec-heading text-center'>Client Testimonials</p>


<div id="carouselExampleIndicators" class="carousel col-lg-8 mx-auto slide" data-bs-ride="carousel" data-bs-interval="2000">
 <div class="carousel-indicators">
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="3" aria-label="Slide 4"></button>
  </div>  <div class="carousel-inner pb-5">
    <div class="carousel-item text-center active">
      <p className='text-warning'><i class="fa-solid fa-star px-1"></i><i class="fa-solid fa-star px-1"></i><i class="fa-solid fa-star px-1"></i><i class="fa-solid fa-star px-1"></i><i class="fa-solid fa-star px-1"></i></p>
      <p>“I’ve noticed such a difference in my skin since using these products. The quality is amazing, and the deals made it even better! Highly recommend to anyone looking to elevate their beauty routine.”</p>
    </div>
    <div class="carousel-item text-center">
      <p className='text-warning'><i class="fa-solid fa-star px-1"></i><i class="fa-solid fa-star px-1"></i><i class="fa-solid fa-star px-1"></i><i class="fa-solid fa-star px-1"></i><i class="fa-solid fa-star px-1"></i></p>
      <p>“Not only did I get a great discount, but my order arrived quickly and beautifully packaged. I felt pampered before I even opened it!”</p>
    </div>
    <div class="carousel-item text-center">
      <p className='text-warning'><i class="fa-solid fa-star px-1"></i><i class="fa-solid fa-star px-1"></i><i class="fa-solid fa-star px-1"></i><i class="fa-solid fa-star px-1"></i><i class="fa-solid fa-star px-1"></i></p>
      <p>"Skin feels so much better!" Used the cream for a week and already seeing changes. Feels light, smells good. Definitely worth it!</p>
    </div>
    <div class="carousel-item text-center">
      <p className='text-warning'><i class="fa-solid fa-star px-1"></i><i class="fa-solid fa-star px-1"></i><i class="fa-solid fa-star px-1"></i><i class="fa-solid fa-star px-1"></i><i class="fa-solid fa-star px-1"></i></p>
      <p>"So easy to order!" Website was simple, checkout was quick, and my order came right on time. No complaints at all!</p>
    </div>
  </div>
</div>


  </div>
</section>
{/* Testimonial section ends */}

    </>
  )
}

export default About
